import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const createEmployee = async (businessId, payload) => {
  try {
    let resp = await http.post(`${URL}/employee/${businessId}/create`, payload);
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};

export const getEmployee = async (businessId,params={}) => {
  try {
       const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(`${URL}/employee/${businessId}/get-employees?${queryString}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const getOneEmployee = async (businessId, employeeID, data) => {
  // console.log("employee Id", employeeID);
  try {
    const result = await http.get(
      `${URL}/employee/${businessId}/${employeeID}`,
      data
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};
export const updateEmployee = async (businessId, employeeID, data) => {
  try {
    const res = await http.put(
      `${URL}/employee/${businessId}/${employeeID}`,
      data
    );
    return res;
  } catch (error) {
    errorHandler(error);
  }
};

export const deleteEmployee = async (businessId, employeeID) => {
  try {
    const res = await http.delete(
      `${URL}/employee/${businessId}/${employeeID}`
    );
    return res;
  } catch (error) {
    errorHandler(error);
  }
};
export const getDashboardStats = async (businessId, date = null) => {
  try {
    const params = date ? { date } : {};
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(`${URL}/employee/${businessId}/dashboard/stats?${queryString}`);
    return resp;
  } catch (error) {
    console.error("Error fetching dashboard stats:", error);
    errorHandler(error);
  }
};

// Get today's attendance
export const getTodayAttendance = async (businessId, date = null) => {
  try {
    const params = date ? { date } : {};
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(`${URL}/employee/${businessId}/attendance/today?${queryString}`);
    return resp;
  } catch (error) {
    console.error("Error fetching today's attendance:", error);
    errorHandler(error);
  }
};

// Batch update attendance
export const batchUpdateAttendance = async (businessId, attendanceData) => {
  try {
    let resp = await http.post(
      `${URL}/employee/${businessId}/attendance/batch-update`,
      { attendance: attendanceData }
    );
    return resp;
  } catch (error) {
    console.error("Error updating batch attendance:", error);
    errorHandler(error);
  }
};

// Update employee attendance
export const updateEmployeeAttendance = async (businessId, employeeID, data) => {
  try {
    const res = await http.put(
      `${URL}/employee/${businessId}/attendance/${employeeID}`,
      data
    );
    return res;
  } catch (error) {
    errorHandler(error);
  }
};

// Sync employee data
export const syncEmployeeData = async (businessId, employeeData) => {
  try {
    let resp = await http.post(
      `${URL}/employee/${businessId}/sync-employee-dexie`,
      { employeeData: JSON.stringify(employeeData) }
    );
    return resp;
  } catch (error) {
    console.error("Error syncing employee data:", error);
    errorHandler(error);
  }
};

// Search employees
export const searchEmployees = async (businessId, searchTerm) => {
  try {
    let resp = await http.post(
      `${URL}/employee/search-user`,
      { businessId, searchTerm }
    );
    return resp;
  } catch (error) {
    console.error("Error searching employees:", error);
    errorHandler(error);
  }
};

// Get employee details
export const getEmployeeDetails = async (businessId, employeeID) => {
  try {
    let resp = await http.get(
      `${URL}/employee/user-details`,
      { params: { businessId, employeeID } }
    );
    return resp;
  } catch (error) {
    console.error("Error fetching employee details:", error);
    errorHandler(error);
  }
};

// Export employees to CSV
export const exportEmployees = async (businessId, filters = {}) => {
  try {
    const queryString = new URLSearchParams(filters).toString();
    let resp = await http.get(`${URL}/employee/${businessId}/export?${queryString}`, {
      responseType: 'blob'
    });
    return resp;
  } catch (error) {
    console.error("Error exporting employees:", error);
    errorHandler(error);
  }
};

// Get employee attendance summary
export const getAttendanceSummary = async (businessId, startDate, endDate) => {
  try {
    let resp = await http.get(
      `${URL}/employee/${businessId}/attendance/summary`,
      { params: { startDate, endDate } }
    );
    return resp;
  } catch (error) {
    console.error("Error fetching attendance summary:", error);
    errorHandler(error);
  }
};

// Get employee payroll summary
export const getPayrollSummary = async (businessId, month, year) => {
  try {
    let resp = await http.get(
      `${URL}/employee/${businessId}/payroll/summary`,
      { params: { month, year } }
    );
    return resp;
  } catch (error) {
    console.error("Error fetching payroll summary:", error);
    errorHandler(error);
  }
};